import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./reducers";
import { injectStore } from "../services/http";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable checks if necessary
    }),
});

// Inject the store into the Axios instance
injectStore(store);

export default store;
